module.exports = __webpack_public_path__ + "static/analyse3-1e9977f1aeabaf99b949b99c6f83bd66.png";